import React from 'react';

interface FlagProps {
  className?: string;
  size?: number;
}

export const BrazilFlag: React.FC<FlagProps> = ({ className = '', size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 16"
    className={`rounded-sm border border-gray-200 dark:border-gray-600 ${className}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="16" fill="#009739"/>
    <polygon points="12,2 22,8 12,14 2,8" fill="#FEDD00"/>
    <circle cx="12" cy="8" r="3.5" fill="#012169"/>
    <path d="M9.5,6.5 Q12,5.5 14.5,6.5 Q12,9.5 9.5,6.5" fill="#FEDD00"/>
  </svg>
);

export const USAFlag: React.FC<FlagProps> = ({ className = '', size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 16"
    className={`rounded-sm border border-gray-200 dark:border-gray-600 ${className}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="16" fill="#B22234"/>
    <rect width="24" height="1.23" y="1.23" fill="white"/>
    <rect width="24" height="1.23" y="3.69" fill="white"/>
    <rect width="24" height="1.23" y="6.15" fill="white"/>
    <rect width="24" height="1.23" y="8.62" fill="white"/>
    <rect width="24" height="1.23" y="11.08" fill="white"/>
    <rect width="24" height="1.23" y="13.54" fill="white"/>
    <rect width="9.6" height="8.8" fill="#3C3B6E"/>
    <g fill="white">
      <circle cx="1.6" cy="1.6" r="0.3"/>
      <circle cx="3.2" cy="1.6" r="0.3"/>
      <circle cx="4.8" cy="1.6" r="0.3"/>
      <circle cx="6.4" cy="1.6" r="0.3"/>
      <circle cx="8" cy="1.6" r="0.3"/>
      <circle cx="2.4" cy="2.8" r="0.3"/>
      <circle cx="4" cy="2.8" r="0.3"/>
      <circle cx="5.6" cy="2.8" r="0.3"/>
      <circle cx="7.2" cy="2.8" r="0.3"/>
      <circle cx="1.6" cy="4" r="0.3"/>
      <circle cx="3.2" cy="4" r="0.3"/>
      <circle cx="4.8" cy="4" r="0.3"/>
      <circle cx="6.4" cy="4" r="0.3"/>
      <circle cx="8" cy="4" r="0.3"/>
      <circle cx="2.4" cy="5.2" r="0.3"/>
      <circle cx="4" cy="5.2" r="0.3"/>
      <circle cx="5.6" cy="5.2" r="0.3"/>
      <circle cx="7.2" cy="5.2" r="0.3"/>
      <circle cx="1.6" cy="6.4" r="0.3"/>
      <circle cx="3.2" cy="6.4" r="0.3"/>
      <circle cx="4.8" cy="6.4" r="0.3"/>
      <circle cx="6.4" cy="6.4" r="0.3"/>
      <circle cx="8" cy="6.4" r="0.3"/>
      <circle cx="2.4" cy="7.6" r="0.3"/>
      <circle cx="4" cy="7.6" r="0.3"/>
      <circle cx="5.6" cy="7.6" r="0.3"/>
      <circle cx="7.2" cy="7.6" r="0.3"/>
    </g>
  </svg>
);

export const SpainFlag: React.FC<FlagProps> = ({ className = '', size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 16"
    className={`rounded-sm border border-gray-200 dark:border-gray-600 ${className}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="16" fill="#C60B1E"/>
    <rect width="24" height="8" y="4" fill="#FFC400"/>
    <g transform="translate(6,8)">
      <rect width="4" height="3" y="-1.5" fill="#C60B1E"/>
      <rect width="3" height="2" x="0.5" y="-1" fill="#FFC400"/>
      <rect width="2" height="1" x="1" y="-0.5" fill="#C60B1E"/>
    </g>
  </svg>
);